export default __webpack_public_path__ + "static/media/CloseCircle.d038e07c.svg";